import { useMutation } from "@tanstack/react-query";
import { Narendra_Modi_Election_API_URL } from "../Process";
import { error } from "pdf-lib";

// ********************************************************************Mukesh Patel Election*******************************************************

export const useSetFamilyDetail = () => {
  return useMutation({
    mutationFn: async (payload) => {
      const API_URL = `${Narendra_Modi_Election_API_URL}setFamilyDetail`;

      const response = await fetch(API_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Something went wrong");
      }

      const data = await response.json();
      return data;
    },
  });
};

export const useNotVoterDeath = () => {
  return useMutation({
    mutationFn: async (payload) => {
      const API_URL = `${Narendra_Modi_Election_API_URL}setNoVoterAndDeathStatus`;

      const response = await fetch(API_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Something went wrong");
      }

      const data = await response.json();
      return data;
    },
  });
};
export const useUpdateMobileNumber = () => {
  return useMutation({
    mutationFn: async (payload) => {
      const API_URL = `${Narendra_Modi_Election_API_URL}setVoterMobileNoData`;

      const response = await fetch(API_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Something went wrong");
      }

      const data = await response.json();
      return data;
    },
  });
};

export const useSetNewMember = () => {
  return useMutation({
    mutationFn: async (payload) => {
      const API_URL = `${Narendra_Modi_Election_API_URL}setNewMember`;

      const response = await fetch(API_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Something went wrong");
      }

      const data = await response.json();
      return data;
    },
  });
};

export const useSetChangeHead = () => {
  return useMutation({
    mutationFn: async (payload) => {
      const API_URL = `${Narendra_Modi_Election_API_URL}setNewHeadFamilyDetail`;

      const response = await fetch(API_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        const errorData = await response.json();
        console.log("sdfsdfsadfsadjfkldjsfksdafjsdfa", errorData);
        throw new Error(errorData.message || "Something went wrong");
      }

      const data = await response.json();
      return data;
    },
  });
};

export const useSetExistingVoter = () => {
  return useMutation({
    mutationFn: async (payload) => {
      const API_URL = `${Narendra_Modi_Election_API_URL}setExistingVoterToFamilyDetail`;

      const response = await fetch(API_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Something went wrong");
      }

      const data = await response.json();
      return data;
    },
  });
};

export const useSetUserDetails = () => {
  return useMutation({
    mutationFn: async (payload) => {
      const API_URL = `${Narendra_Modi_Election_API_URL}getUserDetails_V1`;

      const response = await fetch(API_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Something went wrong");
      }

      const data = await response.json();
      return data;
    },
  });
};

export const useSetGramYojanaMembers = () => {
  return useMutation({
    mutationFn: async (payload) => {
      // const API_URL = `${Narendra_Modi_Election_API_URL}setMemberForGramYojna`;
      const API_URL = `${Narendra_Modi_Election_API_URL}setMemberForGramYojnaNew`;

      const response = await fetch(API_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Something went wrong");
      }

      const data = await response.json();
      return data;
    },
  });
};

export const useSetVoterGramYojana = () => {
  return useMutation({
    mutationFn: async (payload) => {
      // const API_URL = `${Narendra_Modi_Election_API_URL}setMemberForGramYojna`;
      const API_URL = `${Narendra_Modi_Election_API_URL}setVoterYojnaDetail`;

      const response = await fetch(API_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Something went wrong");
      }

      const data = await response.json();
      return data;
    },
  });
};

export const useSetUserLogout = () => {
  return useMutation({
    mutationFn: async (payload) => {
      const API_URL = `${Narendra_Modi_Election_API_URL}setUserLogout`;

      const response = await fetch(API_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Something went wrong");
      }

      const data = await response.json();
      return data;
    },
  });
};

export const useUpdateYojanaDetail = () => {
  return useMutation({
    mutationFn: async (payload) => {
      const API_URL = `${Narendra_Modi_Election_API_URL}updateGramYojnaMemberYojnaData`;

      const response = await fetch(API_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Something went wrong");
      }

      const data = await response.json();
      return data;
    },
  });
};


export const useEditGramYojanaMemberDetail = () => {
  return useMutation({
    mutationFn: async (payload) => {
      const API_URL = `${Narendra_Modi_Election_API_URL}updateGramYojnaMemberYojnaData`;

      const response = await fetch(API_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Something went wrong");
      }

      const data = await response.json();
      return data;
    },
  });
};
